export default __webpack_public_path__ + "static/media/4.50f6cca6.png";